<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs
        main-link="welcome"
        :main="$t('dashboardVue.dashboard')"
        :title="$t('myRequest.sorularm')"
      />

      <div class="row">
        <div class="col-xl-8 ">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="lead font-weight-bold">
                    {{ $t('myRequest.sorularm') }}
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            v-if="requests.length <1"
            class="alert alert-info"
          >
            {{ $t('myRequest.uyunSoruTaplmad') }}
          </div>

          <div
            v-for="r in requests"
            :key="r.id"
          >
            <RequestItem
              :show-copy-button="true"
              :active-tab="'request'"
              :r="r"
              @copied="getMyRequests"
            />
          </div>
        </div>
        <div class="col-xl-4 ">
          <div class="list-group">
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start "
              :class="{ 'active': status=== 'ALL' }"
              @click="status='ALL'"
            >
              {{ $t('myRequest.btnSorular') }}
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'ACTIVE' }"
              @click="status='ACTIVE'"
            >
              {{ $t('myRequest.aktivSorular') }}
              <span
                v-if="requestStatistics.ACTIVE>0"
                class="badge bg-success "
              >
                {{ requestStatistics.ACTIVE }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'DRAFT' }"
              @click="status='DRAFT'"
            >
              {{ $t('myRequest.qaralama') }}
              <span
                v-if="requestStatistics.DRAFT>0"
                class="badge bg-dark "
              >
                {{ requestStatistics.DRAFT }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'WAITING' }"
              @click="status='WAITING'"
            >
              {{ $t('myRequest.tsdiqGzlyn') }}
              <span
                v-if="requestStatistics.WAITING>0"
                class="badge bg-warning "
              >
                {{ requestStatistics.WAITING }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'RETURNED' }"
              @click="status='RETURNED'"
            >
              {{ $t('myRequest.geriQaytarlm') }}
              <span
                v-if="requestStatistics.RETURNED>0"
                class="badge bg-warning "
              >
                {{ requestStatistics.RETURNED }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'CLOSED' }"
              @click="status='CLOSED'"
            >
              {{ $t('myRequest.balSorular') }}
              <span
                v-if="requestStatistics.CLOSED>0"
                class="badge bg-danger "
              >
                {{ requestStatistics.CLOSED }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'REJECTED' }"
              @click="status='REJECTED'"
            >
              {{ $t('myRequest.lvEdilmi') }}
              <span
                v-if="requestStatistics.REJECTED>0"
                class="badge bg-danger "
              >
                {{ requestStatistics.REJECTED }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'EXPIRED' }"
              @click="status='EXPIRED'"
            >
              {{ $t('myRequest.mddtiBitmi') }}
              <span
                v-if="requestStatistics.EXPIRED>0"
                class="badge bg-danger "
              >
                {{ requestStatistics.EXPIRED }}
              </span>
            </a>
            <a
              class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-start"
              :class="{ 'active': status=== 'DISCUSSING' }"
              @click="status='DISCUSSING'"
            >
              {{ $t('myRequest.mzakird') }}
              <span
                v-if="requestStatistics.DISCUSSING>0"
                class="badge bg-danger "
              >
                {{ requestStatistics.DISCUSSING }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
    import {mapState} from "vuex";
    import {
        getMyRequests,
    } from "@/repositories/GeneralDataRepository";
    import {mediaBase} from "@/repositories/Repository";
    import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
    import RequestItem from "@/components/parts/RequestItem.vue";

    export default {
      components: {RequestItem},
      data() {
            return {
                mediaBase: mediaBase,
                requests: [],
                status: 'ALL',
                requestStatistics: {}
            }
        },
        computed: {
            ...mapState({
                token: state => state.auth.token,
                user: state => state.auth.user,
                company: state => state.auth.company,
                sessionType: state => state.auth.sessionType,
                profile: state => state.auth.profile,
                position: state => state.auth.position,
            }),


        },
        watch: {
            status() {
                this.getMyRequests();
            }
        },
        mounted() {
            this.status = this.$route.query['status'] || 'ALL';
            this.getMyRequests();
        },
        methods: {
            companyProfiles(companyId) {
                let list = [];
                this.profiles.forEach(p => {
                    if (p.company.id === companyId) {
                        list.push(p);
                    }
                })
                return list;
            },

            getProfileName(keyword) {
                return getProfileName(keyword,this.i18n);
            },
            getCompanyFormat(keyword) {
                return getCompanyFormat(keyword, this.$i18n.locale);
            },
            buildLongId(id) {
                return buildLongId(id, 5);
            },
            getPhoto(path, size) {
                return getPhoto(path, size);
            },

            getMyRequests() {
                getMyRequests(this.token, this.status).then(data => {
                    if (data.code === 200) {

                        this.requests = data.requests;

                        this.requestStatistics = {};
                        data.statistics.forEach(s => {
                            this.requestStatistics[s.keyword] = s.counter;
                        })

                    } else if(data.code === 403) {
                        this.$swal({
                            title: this.$t("generalModal.warningTitle"),
                            text: this.$t("myRequest.personal"),
                            icon: 'error'
                        }).then(() => {
                            this.$router.push({name: 'changeAccount'})
                        })
                    } else {
                        this.$swal({
                            title: `Error ${data.code}`,
                            text: `${data.message}`,
                          icon: 'error'
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                })
            }
        }

    }
</script>
<style>
    div.review canvas {
        position: relative !important;
    }

    div.review input {
        z-index: 1;
        display: inline-block;
    }
</style>
